// Exports
export default {
	"cloudRecordingTile": "cloudRecordingTile_tEOqP",
	"cloudRecordingTileContent": "cloudRecordingTileContent_KtIgo",
	"cloudRecordingTileIcon": "cloudRecordingTileIcon_vtvG3",
	"cloudRecordingTileDescription": "cloudRecordingTileDescription_T+osE",
	"cloudRecordingTileMessage": "cloudRecordingTileMessage_JIiIE",
	"cloudRecordingTileTip": "cloudRecordingTileTip_vEAhB"
};
